export const LIFECELL_WARNING_MESSAGE =
  'This Ukrainian phone number has a Lifecell-issued prefix. SMS verification may fail for some Ukrainian phone numbers, particularly if the number was transferred between carriers. You can continue or use another phone number.';

export const hasLifecellIssuedPrefix = (phoneNumber: unknown): boolean => {
  if (typeof phoneNumber !== 'string') {
    return false;
  }

  const normalizedPhoneNumber = phoneNumber.replace(/[\s()-]/g, '');
  return /^\+380(?:63|73|93)\d{7}$/.test(normalizedPhoneNumber);
};
